// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> parc-at-murfreesboro
// Generated: 2026-10-05T18:32:02.998Z
// Counts: 1 design, 14 content, 17 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#0095ff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitycardgrid.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From resort-style afternoons by the pool to easy evenings with neighbors, every space at Parc at Murfreesboro is designed to elevate the everyday. Explore the amenities that make life here feel effortless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Open-concept homes with smart touches</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into an open-concept home where natural light pours over wood-style floors and granite counters, and smart home technology keeps daily life effortless. Every detail, from the gooseneck faucet to the walk-in closet, was chosen to make your space feel as thoughtful as it is comfortable.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Designed Around You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Resort-style living in north Murfreesboro</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Trade the everyday for sun-soaked afternoons on the pool sundeck and easy evenings by the outdoor firepits. Whether you're working out on your own schedule or catching up with neighbors over a game of bocce, the shared spaces here are built to help you slow down, connect, and feel right at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Room to Live, Space to Gather</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from one, two, and three-bedroom apartment homes featuring open-concept layouts, 9-foot ceilings, and wood-style flooring. Each home is finished with granite countertops, stainless steel appliances, and smart home technology, plus in-home washers and dryers and generous walk-in closets. Select residences add private patios and balconies, sunrooms, and built-in shelving for an elevated everyday living experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Parc at Murfreesboro centers on a resort-style swimming pool with a spacious sundeck, outdoor games, lounge seating, and two cozy outdoor fireplaces made for gathering. Stay active in the 24-hour fitness center with Wellbeats Virtual Fitness Training, then unwind in the clubhouse lounge or the gaming room with friends and neighbors. With a gourmet coffee bar, bark park, and inviting common spaces throughout, it's a vibrant community designed for connection.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "VALUE",
    "customValue": "<p>Parc at Murfreesboro offers thoughtfully designed one, two, and three-bedroom apartments ranging from 686 to 1,403 square feet, featuring granite countertops, stainless steel appliances, and spacious walk-in closets. Community perks include a resort-style pool, a 24-hour fitness center, a social resident lounge, and a full outdoor kitchen for weekend cookouts. Set in the heart of Murfreesboro, you're minutes from the historic downtown square, The Avenue shopping, and MTSU, with Nashville just about 35 minutes away. Schedule a tour today to find your future home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Settle into a Murfreesboro address where resort-style days by the pool give way to easy evenings around the firepits with neighbors. Inside, sunlit one, two, and three-bedroom homes pair modern finishes with the little comforts that make everyday life feel elevated. With historic downtown, MTSU, and Nashville all within easy reach, this is a place you'll love coming home to.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>At Parc at Murfreesboro, your four-legged family members are just as welcome as you are. From wide-open green spaces to fireside courtyards perfect for an evening stroll, our community is designed with you and your pets in mind.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool area with lounge chairs, tables, and apartment buildings in the background."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-fe7e-7666-9ae5-42887b55c50c.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Spend sun-soaked afternoons on the spacious sundeck, then linger into the evening by the outdoor fireplaces. It's a poolside escape that feels like a permanent vacation."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "State-of-the-art fitness center with treadmills and ellipticals overlooking the community."
      },
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-007b-7659-8ba0-fd8a9024d228.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Skip the gym membership and work out on your own schedule with high-tech cardio and strength equipment plus Wellbeats virtual training. Staying active has never felt so convenient."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge with seating, bar, pool table, and shuffleboard."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Lounge"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddc-cad7-73b8-9358-331abd75e426.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Gather over a game of pool or shuffleboard, then settle in at the bar with neighbors. The lounge is your living room beyond the front door — relaxed, social, and always welcoming."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor kitchen with grills, counter space, and TV."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Outdoor Grilling Area"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-6781-717b-9c1d-cd6a89c69137.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Fire up the grills and dine al fresco at our full-service outdoor kitchen. It's the perfect setting for weekend cookouts and easy evenings under the open sky."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-07e7-70ca-99ea-2901e0840bea.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with a brown leather couch, coffee table, and large windows."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-5a4b-7235-8e16-d28fbb154a10.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern apartment building with multiple floors and balconies."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-6233-715e-83a3-bce6cb85c603.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with multiple buildings, a swimming pool, and lush landscaping."
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-1987-7478-b6d2-1804bb8ad05a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings and a clubhouse."
      }
    }
  },
  "gallery.hero_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-2705-7089-9cf7-f58ca0b258c4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with modern lounge chairs and a clubhouse in the background."
      }
    }
  },
  "gallery.hero_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-6233-715e-83a3-bce6cb85c603.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with multiple buildings, a swimming pool, and lush landscaping."
      }
    }
  },
  "gallery.hero_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-30b9-713f-be3e-a874ea49cf5e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with fireplace and modern chairs."
      }
    }
  },
  "petpolicy.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-6233-715e-83a3-bce6cb85c603.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with multiple buildings, a swimming pool, and lush landscaping."
      }
    }
  },
  "petpolicy.lifestyle_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-30b9-713f-be3e-a874ea49cf5e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor seating area with fireplace and modern chairs."
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e81-e9da-76ca-9675-8700f35726a6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern apartment building with gray siding and stone accents."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-28e0-740d-b2e8-774170a818d6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright and airy open-concept living space with kitchen island, dining area, and living room."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019d4e82-2705-7089-9cf7-f58ca0b258c4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with modern lounge chairs and a clubhouse in the background."
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162903/019cfddd-00d6-70b0-9bf7-4b032a6f2328.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with exercise bikes, weights, and fitness equipment"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
